import { useEffect, useState } from 'react'
import parse, { HTMLReactParserOptions, Element } from 'html-react-parser'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import AccordionItem from '@/components/common/AccordionItem'
import { unOrphan } from '@/utils/orphans'
import routes from '@/i18n-routes.config'

function Accordion() {
  const { t, i18n } = useTranslation('faq')
  const { locale, query } = useRouter()
  const [isOpen, setIsOpen] = useState(0)
  const common = i18n.getResourceBundle(locale as string, 'faq')
  const [questions, setQuestions] = useState<
    { content: string; title: string }[]
  >([])

  useEffect(() => {
    const translatedEn = routes[`/${query?.category}`]?.['en']
    const key = (
      translatedEn === '/navipay-application'
        ? '/navipay-app'
        : translatedEn || '/common'
    ).slice(1)
    setQuestions(common?.content[key] || [])
  }, [common, query?.category])

  const handleAccordion = (idx: number) => setIsOpen(idx)

  const parserOptions: HTMLReactParserOptions = {
    replace: (node: any) => {
      if (node.type === 'tag' && node?.name === 'img') {
        const el = node as Element
        return <img {...el.attribs} alt={el.attribs.alt || ''} />
      }
    }
  }

  return (
    <>
      {questions.map((q, i) => (
        <AccordionItem
          key={i}
          question={q.title}
          idx={i}
          isOpen={isOpen === i}
          onClick={handleAccordion}
          wrapWithH2
        >
          {parse(unOrphan(q.content), parserOptions)}
        </AccordionItem>
      ))}
    </>
  )
}

export default Accordion
